import { createContext } from 'react';

import type { BlogPost } from 'components/molecules/JournalGroup';

export const MarketingPageContext = createContext<{
  internalBlogPosts: Array<BlogPost>;
}>({
  internalBlogPosts: [],
});
